import { useContext } from "react";
import Context from "./context";

const useAuth = () => {
	const auth = useContext(Context);
	return auth;
};

export default useAuth;
